<template>
    <div class="simulator-box card-panel ">

        <h2 class="simulator-title" :class="{loaded: cliente, 'with-animation' : carregando}">Seguro</h2>


        <div class="flex-row between-xs">

            <div class="col-lg-5 col-sm-12" v-if="seguroTitular">
                <h3 class="simulator-title subtitle">Titular</h3>
                <input-simulador input-type="price" label="Individual:"  @input="salvarTitular" v-model="seguroTitular.individual" />
                <input-simulador input-type="price" label="Empresarial:" @input="salvarTitular" v-model="seguroTitular.empresarial" />

                <div class="section">
                    <div>
                        <input id="st-temporario-1" type="radio" name="st_temporario" :value="1" v-model.number="seguroTitular.temporario" @input="salvarTitular" />
                        <label for="st-temporario-1">Temporário</label>
                    </div>
                    <div class="mt-3">
                        <input id="st-temporario-0" type="radio" name="st_temporario" :value="0" v-model.number="seguroTitular.temporario" @input="salvarTitular" />
                        <label for="st-temporario-0">Permanente</label>
                    </div>
                </div>

                <div class="section">
                    <div class="flex-row middle-xs">
                        <strong class="col-xs-6">TOTAL TITULAR:</strong>
                        <strong class="col-xs-6 end-xs">{{ somaTitular | dinheiro }}</strong>
                    </div>
                </div>
            </div>

            <div class="col-lg-5 col-sm-12" v-if="seguroConjuge">
                <h3 class="simulator-title subtitle">Cônjuge</h3>
                <input-simulador input-type="price" label="Individual:"  @input="salvarConjuge" v-model="seguroConjuge.individual" />
                <input-simulador input-type="price" label="Empresarial:" @input="salvarConjuge" v-model="seguroConjuge.empresarial" />


                <div class="section">
                    <div>
                        <div>
                            <input id="sc-temporario-1" type="radio" name="sc_temporario" value="1" v-model.number="seguroConjuge.temporario" @input="salvarConjuge" />
                            <label for="sc-temporario-1">Temporário</label>
                        </div>
                        <div>
                            <input id="sc-temporario-0" type="radio" name="sc_temporario" value="0" v-model.number="seguroConjuge.temporario" @input="salvarConjuge" />
                            <label for="sc-temporario-0">Permanente</label>
                        </div>
                    </div>
                </div>

                <div class="section">
                    <div class="flex-row middle-xs">
                        <strong class="col-xs-6">TOTAL CÔNJUGE:</strong>
                        <strong class="col-xs-6 end-xs">{{ somaConjuge | dinheiro }}</strong>
                    </div>
                </div>
            </div>

        </div>

        <div class="section ">
            <div class="flex-row middle-xs">
                <strong class="col-xs-6">TOTAL:</strong>
                <strong class="col-xs-6 end-xs">{{ soma | dinheiro }}</strong>
            </div>
        </div>

    </div>
</template>

<script>

import { api } from "@/helpers/api";
import "@/../static/assets/css/custom/flex.css";
import {debounce} from "lodash";

import InputSimulador from '@/components/common/InputSimulador.vue';
import SvgPercentage from '@/components/common/svg/SvgPercentage.vue';
export default {
    name: "seguro",

    components: {InputSimulador, SvgPercentage},

    data() {

        return {

            cliente: null,
            seguroTitular: null,
            seguroConjuge: null,
            carregando   : false,
        }
    },

    async created() {

        const {id} = this.$route.params;

        const {data: {result: {data: cliente}}} = await api.get(`cliente/${id}`);

        this.seguroTitular = {
            cliente_id: cliente.cliente_id,
            tipo: 'T',
            ...cliente.seguros.find(item => item.tipo == 'T')
        };

        this.seguroConjuge = {
            cliente_id: cliente.cliente_id,
            tipo: 'C',
            ...cliente.seguros.find(item => item.tipo == 'C')
        };

        this.cliente = cliente;
    },

    computed: {

        somaTitular() { return this.somaSeguro(this.seguroTitular) },

        somaConjuge() { return this.somaSeguro(this.seguroConjuge) },

        soma() { return this.somaTitular + this.somaConjuge },
    },

    methods: {

        somaSeguro(seguro) {

            if (! seguro) return;

            let keys = [
                "empresarial",
                "individual"
            ];

            let total = 0;

            keys.forEach(key => {
                let num = parseFloat(seguro[key]);

                total += isNaN(num) ? 0 : num;
            });

            return total
        },

        salvarTitular(e) {
            this.salvar(this.seguroTitular)
        },

        salvarConjuge() { this.salvar(this.seguroConjuge) },

        salvar: debounce(async function(seguro) {

            // if (seguro.temporario === undefined) return;

            this.carregando = true;

            await api.put('seguro', seguro)
            .finally(() => setTimeout(() => this.carregando = false, 2000))

        }, 250)
    },

    watch: {
        carregando(carregando) {
            this.$emit('update:carregando', carregando);
        }
    }
}
</script>

<style lang="scss" >
    @import '../../assets/sass/simulador.scss';
</style>



// WEBPACK FOOTER //
// src/components/clientes/Seguros.vue